// extracted by mini-css-extract-plugin
export var bottomRightDock = "_31-0";